import { render } from "./DonationInfo.vue?vue&type=template&id=180de1aa&ts=true"
import script from "./DonationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationInfo.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/style-two/DonationInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "180de1aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('180de1aa', __exports__)) {
    api.reload('180de1aa', __exports__)
  }
  
  module.hot.accept("./DonationInfo.vue?vue&type=template&id=180de1aa&ts=true", () => {
    api.rerender('180de1aa', render)
  })

}


export default __exports__